export default __webpack_public_path__ + "static/media/img-0265-saudi-arabia-full-face.03640b48.png";